import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getStudioList = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/productivity-host/studios' });

  return data;
};

export default getStudioList;
